import { CameraFeed } from "./CameraFeed";
import { useCameras } from "../hooks/useCameras";

interface CameraPanelProps {
  streamBase: string;
}

export function CameraPanel({ streamBase }: CameraPanelProps) {
  const { cameras, refresh } = useCameras();

  return (
    <div className={`camera-panel ${cameras.length === 0 ? "camera-panel--compact" : ""}`}>
      {cameras.length > 0 && (
        <div className="camera-panel__header">
          <h2 className="camera-panel__title">Cameras</h2>
        </div>
      )}

      <div className="camera-panel__body">
        {cameras.length === 0 ? (
          <div
            className="camera-panel__compact-text"
            role="status"
            title="No cameras connected — the column expands when a camera agent comes online"
          >
            <span aria-hidden="true">📷</span>
            <span>No cameras</span>
          </div>
        ) : (
          cameras.map((camera) => (
            <CameraFeed
              key={camera.id}
              camera={camera}
              streamBase={streamBase}
              onProfileChanged={refresh}
            />
          ))
        )}
      </div>
    </div>
  );
}
